import React, { useEffect, useRef, useState } from "react";
import { C, font } from "../../../../lib/styles.js";
import {
  SESSION_TYPES, SESSION_TYPE_LABELS, SESSION_TYPE_COLORS, SESSION_LOCATION_FIELDS,
} from "../../../../lib/constants.js";
import {
  BLANK_SESSION, defaultDateFor, sortSessions, validateSessionAdd,
} from "../../../../lib/utils.js";

const STC = SESSION_TYPE_COLORS(C);
const DESC = { flight: "travel day", setup: "pre-capture", capture: "scan day", strike: "deinstall" };

export default function AddDayMenu({ job, selectedSession, sortedSessions, onAdd }) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    window.addEventListener("mousedown", close);
    return () => window.removeEventListener("mousedown", close);
  }, [open]);

  const addType = (type) => {
    const existing = job.sessions || [];
    const newSess = { ...BLANK_SESSION(), sessionType: type, date: defaultDateFor(type, existing) };
    // Inherit from selected session, then last-sorted, then job root — matches the flow of chaining a new day onto existing ones.
    const ref = (selectedSession !== null && sortedSessions[selectedSession]) || sortedSessions[sortedSessions.length - 1] || job;
    SESSION_LOCATION_FIELDS.forEach(f => { if (ref && ref[f]) newSess[f] = ref[f]; });
    newSess.isStudio = !!(ref && ref.isStudio);
    const check = validateSessionAdd({ sessions: existing }, newSess);
    if (!check.ok) { setError(check.reason); return; }
    const sorted = sortSessions([...existing, newSess]);
    onAdd(sorted, newSess.id);
    setOpen(false);
    setError("");
  };

  return (
    <div ref={wrapRef} style={{ position: "relative", display: "inline-block", marginTop: 10 }}>
      <button
        onClick={() => { setOpen(o => !o); setError(""); }}
        style={{
          background: "transparent", border: `1px solid ${C.border}`, borderRadius: 6,
          padding: "6px 12px", color: C.text, fontSize: 12, fontFamily: font, fontWeight: 400,
          cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6,
        }}
      >
        + Add Day <span style={{ color: C.muted, fontSize: 10 }}>▾</span>
      </button>
      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 6px)", left: 0,
          background: C.surface, border: `1px solid ${C.border}`, borderRadius: 6,
          padding: 4, minWidth: 230, zIndex: 5,
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
        }}>
          {SESSION_TYPES.map(type => (
            <div
              key={type}
              onClick={() => addType(type)}
              onMouseEnter={e => e.currentTarget.style.background = C.surfaceAlt}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}
              style={{
                padding: "8px 10px", fontSize: 12, color: C.text,
                cursor: "pointer", borderRadius: 4,
                display: "flex", alignItems: "center", gap: 8,
              }}
            >
              <span style={{ width: 8, height: 8, borderRadius: "50%", background: STC[type], flexShrink: 0 }} />
              <span>{SESSION_TYPE_LABELS[type]}</span>
              <span style={{ fontSize: 10, color: C.muted, marginLeft: "auto" }}>{DESC[type] || ""}</span>
            </div>
          ))}
        </div>
      )}
      {error && <div style={{ marginTop: 6, fontSize: 11, color: C.danger }}>{error}</div>}
    </div>
  );
}
